import React from "react";

const variantMap = {
  h1: { tag: "h1", className: "text-4xl font-normal leading-tight" },
  h2: { tag: "h2", className: "text-3xl font-normal leading-tight" },
  h3: { tag: "h3", className: "text-2xl font-normal leading-tight" },
  h4: { tag: "h4", className: "text-xl font-normal leading-tight" },
  h5: { tag: "h5", className: "text-lg font-medium leading-tight" },
  h6: { tag: "h6", className: "text-base font-semibold leading-tight" },
  subtitle1: { tag: "h6", className: "text-base font-normal leading-normal" },
  subtitle2: { tag: "h6", className: "text-sm font-medium leading-normal" },
  body1: { tag: "p", className: "text-sm leading-normal" },
  body2: { tag: "p", className: "text-xs leading-normal" },
  caption: { tag: "span", className: "text-xs text-farmazon-text-muted leading-normal" },
  overline: { tag: "span", className: "text-xs uppercase tracking-wide leading-normal" },
};

const colorMap = {
  textPrimary: "text-farmazon-text",
  textSecondary: "text-farmazon-text-muted",
  primary: "text-[var(--primaryColor)]",
  error: "text-red-600",
  inherit: "text-inherit",
};

const Typography = ({
  variant = "body1",
  component,
  color,
  align,
  gutterBottom = false,
  noWrap = false,
  className = "",
  children,
  ...rest
}) => {
  const { tag, className: variantClassName } = variantMap[variant] || variantMap.body1;
  const Tag = component || tag;
  const alignClass =
    align === "center" ? "text-center" : align === "right" ? "text-right" : "";

  return (
    <Tag
      className={`m-0 ${variantClassName} ${colorMap[color] || "text-farmazon-text"} ${alignClass} ${
        gutterBottom ? "mb-2" : ""
      } ${noWrap ? "truncate" : ""} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Typography;
